import { Box, Stack, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useParams } from "react-router-dom";

import MilestoneProgressBars from "../progressBar/milestoneProgressBar";
import EditMIlestone from "../../../../components/Milestone/EditMilestone";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import {
  useEpic,
  useEpicThroughId,
} from "../../../../utils/reactQuery/epics";
import { useResponsive } from "../../../../hooks/useResponsive";
import MergeMilestonePopUp from "../mergeMilestone/MergeMilestonePopUp";
import GantChartSwitch from "../milestoneGantchart";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

function MilestoneSection({ boardName }) {
  const [editMIlestone, setEditMilestone] = useState(false);
  const [milestone] = useCustomSearchParams("milestone");
  const [allMilestones, setAllMilestones] = useState([]);
  const [openMergeMilestone, setOpenMergeMilestone] = useState(false);
  const { id } = useBoardIdByKey();
  const { epics: milestones } = useEpic(id);

  const isMobile = useResponsive("down", "md");
  const { epics } = useEpicThroughId(milestone);

  useEffect(() => {
    if (milestones) {
      setAllMilestones(
        milestones?.data?.data?.responseData?.filter(
          (item) => item.is_locked === false
        )
      );
    }
  }, [milestones]);

  return (
    <>
      
      <div className="milestone-cont" onClick={(e) =>{
       if (e.target.closest(".gant-chart-switch")) {
        return;
      }
      setEditMilestone(true);
  
      }}
      >
        <Stack
          direction="row"
          flexWrap={"wrap"}
          rowGap={isMobile ? 1 : 1.5}
          alignItems="center"
          justifyContent="space-between"
          spacing={isMobile ? 0 : 4}
          width="100%"
          pt={isMobile ? "4px" : ""}
        >
          {
          !isMobile && (
            <Stack direction="row" alignItems="center">
              <GantChartSwitch />
            </Stack>
          )}
          
          <Box className="milestone-progress">
            <MilestoneProgressBars
              allocatedHours={
                epics?.data?.data.responseData?.total_allocated_hours
              }
              hoursSpent={epics?.data?.data.responseData?.total_hours_spent}
              exceedHours={epics?.data?.data.responseData?.total_exceeded_hours}
              remainingHours={
                epics?.data?.data.responseData?.total_remaining_hours
              }
            />
          </Box>
          {/* {!isMobile && ( */}
            <Stack>
              <Stack direction="row" className={`d-flex align-items-center ${isMobile ? "mobile-milestone-date-container" : ""}`}>
                <p className="milestone_label">Target Date {isMobile ? "" : ": "} </p>
                <p className="milestone_value" style={{ marginLeft: "4px" }}>
                  {epics?.data?.data.responseData?.epic.target_release_date
                    ? moment(
                        epics?.data?.data.responseData?.epic.target_release_date
                      ).format("MM/DD/YYYY")
                    : "NA"}
                </p>
              </Stack>
            </Stack>
          {/* )} */}
        </Stack>
      </div>
      {editMIlestone && (
        <EditMIlestone
          boardName={boardName}
          open={editMIlestone}
          handleClose={() => setEditMilestone(false)}
        />
      )}
      {openMergeMilestone && (
        <MergeMilestonePopUp
          open={openMergeMilestone}
          close={setOpenMergeMilestone}
          unlockedMilestone={allMilestones}
          isSelectSourceMilestone={true}
          SelectedSourceMileStone={epics}
        />
      )}
    </>
  );
}

export default MilestoneSection;
